<template>
	<div class="product-card">
		<router-link class="img" :to="'/product/' + product.id">
			<img :src="product.img" :alt="product.name">
			<div class="badge" v-if="product.badge">{{ product.badge }}</div>
		</router-link>
		<div class="info">
			<p class="name">{{ product.name }}</p>
			<p class="price"><span>$</span>{{ product.price }}</p>
			<button class="add-btn" :class="{ active: loading }" @click="addToCart()">
				<span class="spinner" v-if="loading"></span>
				<i class="material-icons" v-else>add</i>
			</button>
			<Rating :rating="product.rating" />
		</div>
	</div>
</template>

<script>
	import { toast } from '@/utils'
	export default{
		name: 'Product',
		props: ['product'],
		data: () => ({
			loading: false
		}),
		components: {
			Rating: () => import(/* webpackChunkName: "Rating" */ '@/components/Rating.vue')
		},
		methods: {
			addToCart(){
				this.loading = true
				setTimeout(() => {
					let o = this.$store.state.cart.find(e => e.id === this.product.id)
					if(o){
						o.qty++
						toast('+1 added')
					}else{
						this.$store.state.cart.push({ ...this.product, qty: 1 })
						toast('added to cart')
					}
					this.loading = false
				}, 350)
			}
		}
	}
</script>

<style>
	.product-card{
		border-radius: 10px;
		box-shadow: 0 3px 10px rgba(0, 0, 0, 0.08);
		background-color: #fff;
	}
	.product-card .img{
		display: block;
		height: calc(100% - 100px);
		position: relative;
	}
	.product-card .img img{
		width: 100%;
		height: 100%;
		border-radius: 10px 10px 0 0;
	}
	.product-card .img .badge{
		border-radius: 2px 2px 0 2px;
		position: absolute;
		top: 10px;
		right: -16px;
		padding: 3px 7px;
		letter-spacing: 1px;
		word-spacing: 3px;
		color: #fff;
		font-size: 0.8em;
		background-color: #F44336;
		text-transform: uppercase;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
	}
	.product-card .img .badge:after{
		content: '';
		display: inline-block;
		position: absolute;
		top: 100%;
		right: 0;
		border-top: 8px solid #E23124;
		border-left: 8px solid #E23124;
		border-bottom: 8px solid transparent;
		border-right: 8px solid transparent;
		box-shadow: inset 0 1px 5px rgba(0, 0, 0, 0.3);
	}
	.product-card .info{
		height: 100px;
		box-sizing: border-box;
		padding: 15px 15px 0 15px;
		position: relative;
	}
	.product-card .info .name{
		font-size: 1em;
		color: #1B1B1B;
	}
	.product-card .info .price{
		font-size: 1.3em;
		margin-top: 2px;
		color: #191919;
	}
	.product-card .info .price span{
		font-weight: light;
		color: var(--primary-color);
	}
	.product-card .info .add-btn{
		height: 45px;
		width: 45px;
		border-radius: 50%;
		position: absolute;
		right: 15px;
		top: 0;
		color: #fff;
		font-size: 1.3em;
		background-color: var(--primary-color);
		box-shadow: 0 4px 15px var(--primary-light);
		display: flex;
		justify-content: center;
		align-items: center;
		transform: scale(0) translateY(0);
		transition: background-color 0.33s, transform 0.33s;
	}
	.product-card:hover .info .add-btn, .info .add-btn.active{
		transform: scale(1) translateY(-50%);
	}
	.info .add-btn:hover{
		background-color: var(--primary-dark);
	}
</style>